import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useEffect, } from 'react';
import classnames from 'classnames/bind';
import _ from 'lodash';
import { ColorNames } from '../../../constants/colorVars';
import { formFieldWrapper } from '../formFieldWrapper';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import Button from '../../elementals/button';
import Icon from '../../elementals/icon';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const COMPACT_BREAKPOINT = 550;
const BaseCheckboxButtonField = ({ className = '', elmId = 'base_checkbox_button_field', onChange, onBlur, compact: _compact = false, value, toggle, label, iconName, valueAsArray = false, checked = false, disabled = false, layoutDirection = 'vertical', fluid = false, ...rest }) => {
    const { width } = useWindowDimensions();
    const [compact, setCompact] = useState(_compact || width < COMPACT_BREAKPOINT);
    useEffect(() => {
        setCompact(_compact || width < COMPACT_BREAKPOINT);
    }, [_compact, width]);
    const newLabel = (_jsxs(_Fragment, { children: [iconName ? (_jsx(Icon, { name: iconName, iconStyle: 'light', color: 'inherit', className: cx('icon', { compact }) })) : (' '), _jsx("span", { className: cx('button-label', { compact }), children: label })] }));
    const defaultButtonClassNames = [
        'checkbox-button',
        layoutDirection,
        className,
        compact ? 'compact' : '',
        fluid ? 'fluid' : '',
    ];
    const classNames = toggle ? [className] : defaultButtonClassNames;
    const handleClick = useCallback((e) => {
        if (disabled || !onChange)
            return;
        const newChecked = !checked;
        let newValue = value;
        if (valueAsArray && typeof value === 'string') {
            newValue = value.split(',');
        }
        const data = {
            value: newValue || '',
            checked: newChecked,
        };
        if (valueAsArray && typeof data.value === 'string') {
            data.value = data.value.split(',');
        }
        onChange(e, data);
    }, [checked, disabled, onChange, value, valueAsArray]);
    const handleBlur = useCallback((e) => {
        if (onBlur) {
            onBlur(e);
        }
    }, [onBlur]);
    const newValue = valueAsArray
        ? Array.isArray(value) && value.join(',')
        : value;
    return (_jsx(Button, { role: 'secondary', isSelected: checked, color: checked ? ColorNames.Action : ColorNames.Gray, elmId: `${elmId}_checkbox_button`, "aria-label": `${elmId}_checkbox_button`, "aria-pressed": checked, "aria-checked": checked, className: cx(...classNames), onClick: handleClick, onBlur: handleBlur, disabled: disabled, value: newValue, size: compact ? 'small' : 'medium', fluid: fluid, ..._.omit(rest, 'size', 'checkboxLabel', 'showAnchor', 'helpContent', 'pendingApproval'), children: newLabel }));
};
const WrappedCheckboxButtonField = formFieldWrapper(fieldProps => (_jsx(BaseCheckboxButtonField, { ...fieldProps })));
const CheckboxButtonField = props => {
    return (_jsx("div", { className: cx({ 'even-spacing': props.layoutDirection === 'vertical' }), children: _jsx(WrappedCheckboxButtonField, { ...props }) }));
};
export default CheckboxButtonField;
//# sourceMappingURL=index.js.map